import { LayoutData } from "../Structur/Aconlayout";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RoleEdit } from "../Components/roleEdit";
import { BildUpload } from "../Structur/BildUpload";
import {
  Switch,
  InputNumber,
  Button,
  Image,
  Form,
  Input,
  Drawer,
  message,
  Watermark,
  Space,
  Divider,
  Card,
  Avatar,
  Row,
  Col,
} from "antd";
import {
  EditOutlined,
  UserOutlined,
  SmileOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { PendingComp } from "../Helper/ProgressComp";

export const AccountEdit = (props) => {
  //console.log(props.email);
  const [showDrawer, setShowDrawer] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const closeDrawer = () => setShowDrawer(false);
  const { user, getOneUser, logoutLogin, saveUserDaten, checkRole, apiBaseUrl } =
    LayoutData();
  const [infoUser, setInfoUser] = useState(); // Antwort aller Daten
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [aktiveRoles, setaktiveRoles] = useState();
  const [forceRender, setForceRender] = useState(false);
  const [watermarkContent, setWatermarkContent] = useState("");

  const [editArt, setEditArt] = useState();
  const [editCaption, setEditCaption] = useState();

  const handleForceRender = () => {
    console.log("Force render initiated vor Set", forceRender);
    setForceRender((prev) => !prev); // Ändert den Zustand und erzwingt ein erneutes Rendern
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const [allRoles, setAllRoles] = useState(null);
  const [url1, setUrl1] = useState("");

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    if (apiBaseUrl) {
      setUrl1(`${apiBaseUrl}api/getRoles?name=?`);
    }
  }, [apiBaseUrl]);
  const {
    isPending: isPending1,
    error: error1,
    data: alleRollesData,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) => {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return null; //Promise.resolve({});
      }
    },
  });
  useEffect(() => {
    if (alleRollesData) {
      console.log("XXX alleRollesData", alleRollesData);
      setAllRoles(alleRollesData);
    }
  }, [alleRollesData]);

  useEffect(() => {
    //console.log("-> useEffect Email aus dem Query-String:", email);
    //console.log("-> useEffect Prüfe ", props.email, user.name, email);
    let neueEmail = user.name;
    if (email) {
      neueEmail = email;
    }
    if (props.email) {
      neueEmail = props.email;
    }
    /*
    const fetchAllRoles = async () => {
      try {
        const myAllRoles = await getAllRoles("?", user.bearer);
        setAllRoles(myAllRoles);
      } catch (error) {
        console.log("-> useEffect Error alle Roles lesen", error);
      }
    };
    */
    const fetchData = async () => {
      try {
        console.log(
          "-> useEffect Vor getOneUser props/aktEMail:",
          props,
          neueEmail
        );
        const daten = await getOneUser(neueEmail, user.bearer);
        console.log(
          "-> useEffect vor setInfoUser Nach daten Geselsen daten/aktEMail:",
          daten,
          neueEmail
        );
        setInfoUser(daten);
        /*
        console.log(
          "-> useEffect nach setInfoUser Nach daten Geselsen daten/aktEMail:",
          daten,
          neueEmail
        );
        */
        if (form) {
          form.setFieldsValue(daten);
          //console.log("form.setFieldsValue(infoUser)", daten);
        }
        setaktiveRoles(daten.roles);
        setWatermarkContent(daten.email);
      } catch (error) {
        console.error(
          "-> useEffect Fehler beim Abrufen von Benutzerinformationen",
          error
        );
      }
    };
    const doIt = async () => {
      //await fetchAllRoles();
      await fetchData(); // Daten beim Mounten der Komponente abrufen
    };
    doIt();
  }, [forceRender, email]); // warum es unterwellt ist - funktioniert jedoch !

  const handleChange = (checked) => {
    console.log(`switch to ${checked}`);
  };

  const UserRolesText = (roles) => {
    return (
      <>
        {roles && roles.length > 0 ? (
          <>
            Aktive Benutzerrollen:{" "}
            <b>
              {roles.map((role, index) =>
                index === roles.length - 1 ? role : `${role}, `
              )}
            </b>
          </>
        ) : (
          <>Keine aktiven Benutzerrollen</>
        )}
      </>
    );
  };

  const handleGoBack = () => {
    navigate("/alleUsers");
  };

  const onFinishSave = async (daten) => {
    daten.userName = infoUser.userName;
    daten.roles = infoUser.roles;
    setaktiveRoles(daten.roles);
    //messageApi.info("Versuche die Datenzu speichern");
    console.log(daten);
    let respo = await saveUserDaten(daten, user.bearer);
    messageApi.info(respo.data.message);
    //console.log(respo.data.message);
    /*
    setTimeout(() => {
      message.success("Daten wurden vor 5 Sekunden gespeichert");
    }, 5000);
    */
    //navigate("/");
  };

  const setRoles = (value) => {
    console.log("setRoles", value); // Namen im Array
    infoUser.roles = value;
  };

  const statusProps = [
    { label: "0" },
    { label: "1" },
    { label: "2" },
    { label: "3" },
    { label: "4" },
    { label: "5" },
    { label: "6" },
    { label: "7" },
    { label: "8" },
    { label: "9" },
  ];
  const getSwitchEditCode = (label, statusFieldName, defaultChecked) => {
    return (
      <Form.Item
        key={statusFieldName}
        layout="horizontal"
        label={label}
        name={statusFieldName}
        style={{ display: "inline-block", marginLeft: "5px" }}
      >
        <Switch
          onChange={handleChange}
          //defaultChecked={infoUser[statusFieldName]}
          defaultChecked={defaultChecked}
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          name={statusFieldName}
        />
      </Form.Item>
    );
  };

  const getStatusSchalter = (infoUser, von, bis) => {
    return statusProps.map((p, i) => {
      const statusFieldName = "status" + i;
      if (i >= von - 1 && i < bis)
        return (
          <Form.Item
            key={statusFieldName}
            layout="horizontal"
            label={p.label}
            name={statusFieldName}
            style={{
              display: "inline-block",
              marginLeft: "5px",
              marginBottom: 3,
            }}
          >
            <Switch
              onChange={handleChange}
              defaultChecked={infoUser[statusFieldName]}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              name={statusFieldName}
            />
          </Form.Item>
        );
    });
  };
  const infotexteProps = [
    { label: "Text 0" },
    { label: "Text 1" },
    { label: "Text 2" },
    { label: "Text 3" },
    { label: "Text 4" },
    { label: "Text 5" },
    { label: "Text 6" },
    { label: "Text 7" },
    { label: "Text 8" },
    { label: "Text 9" },
  ];
  const getInfoTexteEdits = (infoUser) => {
    return infotexteProps.map((p, i) => {
      const textFieldName = "text" + i;
      return (
        <Form.Item
          key={textFieldName}
          layout="vertical"
          label={p.label}
          name={textFieldName}
          style={{ marginBottom: 3 }}
        >
          <Input placeholder={"Infotext" + i} />
        </Form.Item>
      );
    });
  };

  const handleFinish = (values) => {
    closeDrawer(); //schließen
    onFinishSave(values); //speichern
    handleForceRender(); //neu lesen und anzeigen
  };
  const TextEingaben = ({ art }) => {
    console.log("TextEingaben art", art);
    return (
      <>
        <Form
          layout="vertical"
          onFinish={handleFinish}
          style={{ margin: 0, padding: 0 }}
          initialValues={infoUser}
        >
          {art === 0 && getInfoTexteEdits(infoUser)}
          {art === 1 && AdresseEingaben(art)}
          {art === 2 && AdresseEingaben(art)}
          <br />
          <Form.Item>
            <Button block type="primary" htmlType="submit">
              Speichern
            </Button>
          </Form.Item>
        </Form>
      </>
    );
  };

  const adress1InputProps = [
    { label: "Name", feld: "name1", place: "Name eingeben" },
    { label: "Adresse", feld: "adresse1", place: "Lieferadresse" },
    { label: "Strasse", feld: "strasse1", place: "Strasse Nr" },
    { label: "Ort", feld: "ort1", place: "Ort der Lieferung" },
    { label: "Plz", feld: "plz1", place: "", isNumber: true },
    { label: "Lkz", feld: "lkz1", place: "" },
    { label: "Info", feld: "info1", place: "" },
  ];
  const adress2InputProps = [
    { label: "Name", feld: "name2", place: "Name eingeben" },
    { label: "Adresse", feld: "adresse2", place: "Rechnungsadresse" },
    { label: "Strasse", feld: "strasse2", place: "Strasse Nr" },
    { label: "Ort", feld: "ort2", place: "Ort" },
    { label: "Plz", feld: "plz2", place: "" },
    { label: "Lkz", feld: "lkz2", place: "" },
    { label: "Info", feld: "info2", place: "" },
  ];
  const getTexteEdits = (infoUser, textProps) => {
    return textProps.map((p, i) => {
      const feldName = p.feld;
      return (
        <Form.Item
          key={feldName}
          layout="vertical"
          label={p.label}
          name={feldName}
          style={{ marginBottom: 3 }}
        >
          {p.isNumber ? (
            <InputNumber placeholder={p.place} />
          ) : (
            <Input placeholder={p.place} />
          )}
        </Form.Item>
      );
    });
  };

  const AdresseEingaben = (nr) => {
    nr > 1 ? (nr = 2) : (nr = 1); // nur 1 und 2 sinnvoll
    return (
      <>
        {nr === 1 && getTexteEdits(infoUser, adress1InputProps)}
        {nr === 2 && getTexteEdits(infoUser, adress2InputProps)}
      </>
    );
  };

  const startShowDrawer = (art, caption) => {
    setEditArt(art);
    setEditCaption(caption);
    setShowDrawer(true);
  };

  const ProfilePicture = ({ base64Image }) => {
    const src = `data:image/jpeg;base64,${base64Image}`;
    //console.log("XXX  ProfilePicture",base64Image);
    return (
      <>
        <Avatar
          size={{
            xs: 48,
            sm: 64,
            md: 80,
            lg: 128,
            xl: 160,
            xxl: 200,
          }}
          src={src}
          alt="Profilbild"
          gab={4}
        />
        {/*<Image src={src} />*/}
      </>
    );
  };
  const uploadOk = () => {
    handleForceRender(); //neu lesen und anzeigen
  };

  return (
    <>
      <div className="page">
        {contextHolder}
        <Space size={13} aria-orientation="vertical">
          <Row>
            <Col>
              {infoUser && infoUser.picture && infoUser.picture !== "" && (
                <ProfilePicture base64Image={infoUser.picture} />
              )}
            </Col>

            <Col>
              <h3>&nbsp;&nbsp;&nbsp; {infoUser && infoUser.userName}</h3>
            </Col>
          </Row>
        </Space>
        <Watermark
          content={["Powered by Aconsoft", "Willkommen", watermarkContent]}
        >
          <Space direction="vertical" size={1}>
            <Card
              //title=""
              /*extra={<a href="#">More</a>} */
              title={
                <>
                  <Row>
                    <Col span={8}>
                      <Button
                        icon={<EditOutlined />}
                        onClick={() => startShowDrawer(0, "Texte zum Benutzer")}
                      >
                        Texte
                      </Button>
                      &nbsp;
                    </Col>
                    <Col span={7}>
                      <Button
                        icon={<EditOutlined />}
                        onClick={() => startShowDrawer(1, "Lieferadresse")}
                      >
                        Liefer
                      </Button>
                    </Col>
                    <Col span={9}>
                      &nbsp;
                      <Button
                        icon={<EditOutlined />}
                        onClick={() => startShowDrawer(2, "Rechnungsadresse")}
                      >
                        Rechnung
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    {checkRole("Admin") && (
                      <>
                        &nbsp;
                        <Button
                          block
                          icon={<EditOutlined />}
                          onClick={handleGoBack}
                        >
                          Alle Benutzer
                        </Button>
                      </>
                    )}
                  </Row>
                </>
              }
              style={{ width: 380 }}
            >
              {/*
            <Button onClick={() => setShowDrawer(true)}>Show Drawer</Button>
            {mitZurueck && (
              <Button block onClick={handleGoBack} style={{ width: "120px" }}>
                Alle Benutzer
              </Button>
            )}
            */}

              {infoUser && (
                <>
                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={(values) => {
                      onFinishSave(values);
                      navigate("/");
                    }}
                    style={{ margin: 0, padding: 0 }}
                    initialValues={infoUser}
                  >
                    {/*
                <Form.Item label="Username:" name="userName">
                  <Input
                    placeholder="Benutzername als EMail"
                    required
                    prefix={<UserOutlined />}
                    allowClear={false}
                    defaultValue={infoUser.userName}
                    disabled={true}
                    value={infoUser.userName}
                  ></Input>
                </Form.Item>
            */}
                    {checkRole("Admin") && (
                      <>
                        <Divider style={{ borderColor: "green", margin: 0 }}>
                          Benutzerrollen zuweisen
                        </Divider>

                        <Form.Item label="" name="roles">
                          {infoUser.roles && allRoles && (
                            <RoleEdit
                              roles={infoUser.roles}
                              allRoles={allRoles}
                              setRoles={setRoles}
                            />
                          )}
                        </Form.Item>
                      </>
                    )}
                    <Divider style={{ borderColor: "green", margin: 0 }}>
                      Freigabe festlegen
                    </Divider>
                    <Space direction="horizontal" size={5}>
                      {getStatusSchalter(infoUser, 1, 5)}
                    </Space>
                    <Space direction="horizontal" size={5}>
                      {getStatusSchalter(infoUser, 6, 10)}
                    </Space>
                    <Row>
                      <Col>
                        {getSwitchEditCode(
                          "Email Confirmed",
                          "emailConfirmed",
                          infoUser.emailConfirmed
                        )}
                      </Col>
                      <Col>
                        Avatar:
                        <br />
                        {infoUser && (
                          <BildUpload
                            toUserName={infoUser.userName}
                            email={infoUser.email}
                            uploadOk={uploadOk}
                          />
                        )}
                      </Col>{" "}
                    </Row>
                    <br></br>

                    {/*   {getInfoTexteEdits(infoUser)}   */}
                    {aktiveRoles && UserRolesText(aktiveRoles)}
                    {/*  Lieferadresse {AdresseEingaben(1)}*/}
                    {/*  Rechnungsadresse {AdresseEingaben(2)}*/}
                    <Form.Item>
                      <Button block type="primary" htmlType="submit">
                        Speichern
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              )}
            </Card>
          </Space>
        </Watermark>
        <Drawer
          destroyOnClose
          open={showDrawer}
          title={editCaption && editCaption}
          onClose={closeDrawer}
        >
          <TextEingaben art={editArt} />
        </Drawer>
        <PendingComp isPending={isPending1} />
      </div>
    </>
  );
};

//const [editArt, setEditArt] = useState();
//const [editCaption, setEditCaption] = useState();
